import type { RoleName } from '../shared-components/Types/Role';

/**
 * Authorization Roles
 */
const authRoles = {
  admin: ['admin'],
  staff: ['admin', 'staff'],
  user: ['admin', 'staff', 'user', 'Outside Sales'],
  onlyGuest: [],
  AllUsers: [
    'Guest',
    'Super Admin',
    'Admin',
    'Sales',
    'Assistant',
    'Opener',
    'Closer',
    'Processor',
    'Researcher',
    'Outside Sales',
    'Referral Partner',
    'Company Owner',
    'Account Manager',
    'AI Agent',
  ],
  Orders: [
    'Super Admin',
    'Admin',
    'Sales',
    'Assistant',
    'Coordinator',
    'Advisor',
    'Processor',
    'Researcher',
    'Outside Sales',
    'Referral Partner',
    'Company Owner',
    'Account Manager',
    'AI Agent',
  ],
  Sales: [
    'Super Admin',
    'Admin',
    'Sales',
    'Assistant',
    'Coordinator',
    'Advisor',
    'Processor',
    'Researcher',
    'Account Manager',
    'AI Agent',
  ],
  Companies: [
    'Super Admin',
    'Admin',
    'Sales',
    'Assistant',
    'Advisor',
    'Processor',
    'Researcher',
    'Account Manager',
    'AI Agent',
  ],
  Process: ['Super Admin', 'Admin', 'Processor', 'Account Manager'],
  Subscriptions: [
    'Super Admin',
    'Admin',
    'Sales',
    'Advisor',
    'Processor',
    'Account Manager',
    'AI Agent',
  ],
  ServiceConfig: ['Super Admin', 'Admin', 'Processor'],
  Payments: ['Super Admin'],
  Tickets: [
    'Super Admin',
    'Admin',
    'Sales',
    'Assistant',
    'Advisor',
    'Coordinator',
    'Processor',
    'Account Manager',
    'AI Agent',
  ],
  Reporting: [
    'Super Admin',
    'Admin',
    'Sales',
    'Advisor',
    'Coordinator',
    'Processor',
    'Account Manager',
    'AI Agent',
  ],
  Goals: ['Super Admin', 'Admin', 'Outside Sales'],
  UserManagement: ['Super Admin', 'Admin', 'Outside Sales', 'Account Manager'],
  LicenseeAdmin: ['Super Admin', 'Admin'],
  SystemAdmin: ['Super Admin'],
  MessagingConfig: ['Super Admin', 'Admin'],
  AllUsersData: ['Super Admin', 'Admin'],
  AllLicenseesData: ['Super Admin', 'Account Manager', 'Processor'],
  ImpersonateUser: ['Super Admin', 'Admin', 'Account Manager'],
  Referral: [
    'Super Admin',
    'Admin',
    'Outside Sales',
    'Referral Partner',
    'Company Owner',
    'Account Manager',
  ],
  ReferralCompany: ['Super Admin', 'Admin', 'Outside Sales', 'Company Owner', 'Account Manager'],
  CompanySummary: ['Company Owner'],
  Testimonials: ['Company Owner'],
} as const satisfies Record<string, readonly RoleName[]>;

export default authRoles;
export type RolePermissionName = keyof typeof authRoles;
